export type NonNegative = ['non_negative', number];
export const NonNegative = {
  zero: (): NonNegative => ['non_negative', 0],
  create: (value?: number): NonNegative => ['non_negative', value ?? 0],
  decrement: ([, value]: NonNegative): NonNegative => [
    'non_negative',
    value - 1 > -1 ? value : 0,
  ],
  increment: ([, value]: NonNegative): NonNegative => [
    'non_negative',
    value + 1,
  ],
  is_zero: ([, value]: NonNegative): boolean => value === 0,
};
